export default "__VITE_ASSET__CRxzF_Yn__"